import { makeStyles } from '@material-ui/core/styles';
import range from 'lodash/fp/range';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { SimpleDropdown } from '~/modules/common/components';

const useStyles = makeStyles(theme => ({
  container: {
    width: '100%'
  },
  select: {
    paddingBottom: theme.spacing(0.75),
    fontSize: theme.typography.body2.fontSize,
    height: '1.2rem'
  },
  root: {
    flexGrow: 1,
    flexShrink: 1,
    display: 'inline-flex',
    maxWidth: 170,
    '& .MuiFormControl-root .MuiFilledInput-root': {
      borderTopLeftRadius: 0
    }
  }
}));

const SemiMonthlyDaysDropdown = ({
  value,
  onChange,
  hiddenLabel = false,
  classes: classesOverride,
  selectProps,
  inputLabelProps
}) => {
  const classes = useStyles({ classes: classesOverride });
  const intl = useIntl();
  const options = useMemo(
    () =>
      range(1, 16).map(day => ({
        id: day.toString(),
        displayText: intl.formatMessage({
          id: `billPlan.semiMonthlyDays.${day}`.toString()
        })
      })),
    [intl]
  );

  const selectedValue = useMemo(
    () => options.find(x => value && x.id === (value % 15 || 15).toString()),
    [options, value]
  );

  const dropdownClasses = useMemo(
    () => ({
      container: classes.container,
      select: classes.select
    }),
    [classes.container, classes.select]
  );

  return (
    <div className={classes.root}>
      <SimpleDropdown
        options={options}
        onChange={onChange}
        noneOption={false}
        classes={dropdownClasses}
        value={selectedValue}
        disableSort
        variant="filled"
        hiddenLabel={hiddenLabel}
        selectProps={selectProps}
        inputLabelProps={inputLabelProps}
      />
    </div>
  );
};

SemiMonthlyDaysDropdown.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  hiddenLabel: PropTypes.bool,
  classes: PropTypes.object,
  selectProps: PropTypes.object,
  inputLabelProps: PropTypes.object
};

export default SemiMonthlyDaysDropdown;
